document.addEventListener('DOMContentLoaded', function () {

    // Selected Hotel Container
    var hotelCon = document.querySelector('.contact-hotel-selected');
    var hotelConName = document.querySelector('.contact-hotel-contact h4');
    var hotelConUrl = document.querySelector('.contact-hotel-url');
    var hotelConAddress = document.querySelector('.contact-hotel-address');
    var hotelConNumber = document.querySelector('.contact-hotel-number');
    var hotelConEmail = document.querySelector('.contact-hotel-email');
    var hotelConMap = document.getElementById('contactHotelMap');

    var submitBtn = document.getElementById('contactHotelsSubmit');
    if (submitBtn) {
        submitBtn.addEventListener('click', function () {
            var select = document.getElementById('contactHotels');
            var hotelID = select ? select.value : '';

            if (!hotelID) {
                if (hotelCon) hotelCon.style.display = 'none';
            } else {
                if (hotelCon) hotelCon.style.display = '';

                var hotelContactData = document.querySelector('.contact-hotel-data[data-hotel-id="' + hotelID + '"]');
                if (!hotelContactData) return;

                var hotelName = hotelContactData.dataset.hotelName || '';
                var hotelUrl = hotelContactData.dataset.hotelUrl || '';
                var hotelAddress = hotelContactData.dataset.hotelAddress || '';
                var hotelNumber = hotelContactData.dataset.hotelNumber || '';
                var hotelNumberRaw = hotelNumber.replace(/ /g, '');
                var hotelEmail = hotelContactData.dataset.hotelEmail || '';

                var hotelLongitude = hotelContactData.dataset.hotelLongitude;
                var hotelLatitude = hotelContactData.dataset.hotelLatitude;

                if (hotelConName) hotelConName.innerHTML = hotelName;
                if (hotelConUrl) hotelConUrl.setAttribute('href', hotelUrl);
                if (hotelConAddress) {
                    var span = hotelConAddress.querySelector('span');
                    if (span) span.innerHTML = hotelAddress;
                }
                if (hotelConNumber) {
                    hotelConNumber.setAttribute('href', 'tel:' + hotelNumberRaw);
                    var spanNum = hotelConNumber.querySelector('span');
                    if (spanNum) spanNum.innerHTML = hotelNumber;
                }
                if (hotelConEmail) hotelConEmail.setAttribute('href', 'mailto:' + hotelEmail);

                // Note: map/marker code was left commented in the original file.
            }
        });
    }

});


